import React, {useEffect} from 'react';
import appStore from '../../storage/AppStore'
import adminStore from '../../storage/AdminStore'
import {observer} from "mobx-react-lite";
import Btn from "../../ui/Btn";
import CompaniesSearch from "./CompaniesSearch";
import PageLayout from "../PageLayout";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";
import NumericPagination from "../NumericPagination";

const AdminCompanies = () => {
    const navigate = useNavigate()
    useEffect(() => {
        if (appStore.user?.is_admin) {
            adminStore.searchCompanies()
        }
    }, [appStore.user])

    const headerTemplate = () => {
        return (
            <div className={"flex justify-content-between align-items-center"}>
                <span>{appStore.tr.clubs}</span>
                <Btn icon={"pi pi-plus"} onClick={() => {
                    navigate('/admin/new_company')
                }}/>
            </div>
        )
    }
    const itemTemplate = (company) => {
        return (
            <div className="grid">
                <div className="col-9 flex">
                    <div>{company.name}</div>
                </div>
                <div className="col-3">
                    <Button
                        icon="pi pi-pencil"
                        className="mr-2"
                        outlined
                        severity="primary"
                        size="small"
                        tooltip={appStore.tr.edit}
                        onClick={() => navigate(`/admin/edit_company/${company.id}`)}
                    />
                    {company.status === 'pending' && (
                        <Button
                            icon="pi pi-check-square"
                            className="mr-2"
                            outlined
                            severity="primary"
                            size="small"
                            tooltip={appStore.tr.approve}
                            onClick={() => {
                                adminStore.confirmStatus(company.id)
                            }}
                        />
                    )}
                </div>

            </div>
        )
    }

    return (
        <PageLayout filters={
            <CompaniesSearch/>
        } pagination={
            <NumericPagination
                query={adminStore.companies_query}
                onPageChange={(page) => {
                    adminStore.companies_query.setProperty("page_number", page);
                    adminStore.searchCompanies()
                }}
            />
        }>
            <DataTable value={adminStore.companies} className="w-full" emptyMessage={appStore.tr.not_found}>
                <Column field="title" header={headerTemplate} body={itemTemplate}/>
            </DataTable>
        </PageLayout>
    );
}

export default observer(AdminCompanies);